// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-content[data-v-36754395]{width:100%;padding:.5rem;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start}", ""]);
// Exports
module.exports = exports;
